import { router } from 'expo-router';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { Fonts } from '@/constants/theme';
import { supabase } from '@/lib/supabase';
import { useAuth } from '@/providers/auth-provider';

export function RoleAccount({
  accent,
  roleLabel,
}: {
  accent: string;
  roleLabel: string;
}) {
  const { profile } = useAuth();

  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={styles.screen}>
        <View style={[styles.glow, { backgroundColor: accent }]} />

        <View style={styles.card}>
          <Text style={[styles.eyebrow, { color: accent }]}>{roleLabel}</Text>
          <Text style={styles.title}>Account</Text>
          <Text style={styles.subtitle}>Your school profile and access details.</Text>
        </View>

        <View style={styles.card}>
          <InfoRow label="Name" value={profile?.full_name || 'Not set'} />
          <InfoRow label="Email" value={profile?.email || 'Not available'} />
          <InfoRow label="Role" value={profile?.role || roleLabel.toLowerCase()} />
          <InfoRow label="School ID" value={profile?.school_id || 'Not available'} />
        </View>

        <Pressable
          onPress={() => {
            void supabase.auth.signOut();
            router.replace('/sign-in');
          }}
          style={styles.signOutButton}>
          <Text style={styles.signOutText}>Sign out</Text>
        </Pressable>
      </View>
    </SafeAreaView>
  );
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <View style={styles.row}>
      <Text style={styles.label}>{label}</Text>
      <Text numberOfLines={2} style={styles.value}>
        {value}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  screen: {
    flex: 1,
    backgroundColor: '#FFFFFF',
    paddingHorizontal: 20,
    paddingTop: 16,
    paddingBottom: 24,
    gap: 16,
  },
  glow: {
    position: 'absolute',
    width: 220,
    height: 220,
    borderRadius: 999,
    top: -70,
    right: -80,
    opacity: 0.35,
  },
  card: {
    borderRadius: 24,
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderColor: '#D5E2D7',
    padding: 20,
    gap: 12,
    shadowColor: '#0D2B1A',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.08,
    shadowRadius: 20,
    elevation: 4,
  },
  eyebrow: {
    fontSize: 12,
    fontFamily: Fonts.rounded,
    fontWeight: '700',
    letterSpacing: 0.8,
    textTransform: 'uppercase',
  },
  title: {
    color: '#173924',
    fontSize: 28,
    lineHeight: 34,
    fontFamily: Fonts.rounded,
    fontWeight: '700',
  },
  subtitle: {
    color: '#5D7162',
    fontSize: 15,
    lineHeight: 22,
    fontFamily: Fonts.serif,
  },
  row: {
    gap: 4,
    paddingVertical: 6,
  },
  label: {
    color: '#6B7E6F',
    fontSize: 12,
    fontWeight: '700',
    textTransform: 'uppercase',
  },
  value: {
    color: '#173924',
    fontSize: 15,
    lineHeight: 22,
  },
  signOutButton: {
    minHeight: 54,
    borderRadius: 18,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1F5A37',
  },
  signOutText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: '700',
    fontFamily: Fonts.rounded,
  },
});
